@if (enabled()) {
  <div
    class="rounded-md py-1 px-2 flex flex-row gap-1 items-center bg-orange-400 cursor-pointer"
    [sntTooltip]="content()?.templateRef || undefined"
  >
    <div class="flex flex-row items-center justify-center">
      <i class="fa-duotone fa-sparkles text-slate-50"></i>
    </div>

    @if (!hideText()) {
      <div [ngClass]="{ 'text-xxs': !small(), 'text-xxxs': small() }">
        <span
          class="uppercase text-slate-50 font-bold"
          [ngClass]="{ 'text-xxs': !small(), 'text-xxxs': small() }"
          >{{ "Nuovo" | transloco }}</span
        >
      </div>
    }
  </div>
}
